import React, { lazy, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useTranslation } from 'react-i18next';
import AuthContext from 'globalservices/auth';

import ParentStyled from '../Login/style';
import { loadStyle, getNewObject, loadPageConfig } from 'globalutils/fmUtils';
import { pageUrls } from 'globalconfig/constants/keys';
import { getLocalStorage } from 'globalservices/storage';
import { getSpireonNewDefaultRoute } from '../Login/fleetLocateLoginUtils';
let Styled = loadStyle(ParentStyled, 'pages/web/Login');
const config = loadPageConfig();
const Content = lazy(() => import(`@/${config.MFAPage[0].name}`));

const MFALogin = (parentProps) => {
  const i18n = useTranslation();
  const commonParentProps = { i18n, Styled };
  const auth = useContext(AuthContext);

  useEffect(() => {
    if (auth?.auth) {
      const postLoginPath =
        getLocalStorage('currentLayout') === 'SpireonNew' ||
        window.$environment?.CURRENT_LAYOUT === 'SpireonNew'
          ? getSpireonNewDefaultRoute()
          : pageUrls.dashboard;
      parentProps.history.push(postLoginPath);
    }
  }, []);
  return (
    <RenderComponent
      {...config.MFAPage[0]}
      parentProps={parentProps}
      commonParentProps={commonParentProps}
      component={Content}
    />
  );
};

const RenderComponent = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  component,
  ...rest
}) => {
  const Component = component;
  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length ? getNewObject(commonParentProps, commonProps) : {})
  };
  return <Component {...rest} {...newProps} />;
};
const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests
  };
};
const mapDispatch = (dispatch) => {
  return {
    authenticteOtp: (data) =>
      dispatch.login.authenticteOtp(data),
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus()
  };
};

export default connect(mapState, mapDispatch)(MFALogin);

MFALogin.propTypes = {
  authenticteOtp: PropTypes.func,
  apiStatus: PropTypes.object.isRequired,
  clearApiStatus: PropTypes.func.isRequired
};
